module.exports = __webpack_public_path__ + "static/img/wuxian-1.b4990fab.png";